var map = {
	"./CadiumWarp.png": 41898,
	"./Frozen_LakeWarp.png": 72669,
	"./Frozen_Tundra_(Extinction)Warp.png": 695,
	"./Hidden_Village_(Extinction)Warp.png": 41823,
	"./Immortal_CitadelWarp.png": 58991,
	"./LateriaWarp.png": 54121,
	"./New_IgnitiaWarp.png": 31649,
	"./PalmayaWarp.png": 76926,
	"./Parum_CityWarp.png": 2946,
	"./Precursor_MountainWarp.png": 74904,
	"./The_Drake_IslesWarp.png": 28259,
	"./The_OrphanageWarp.png": 10206,
	"./The_OutlandsWarp.png": 39195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54590;